import { Utils } from '../utils';
export class Attachment {
    usageType;
    display;
    contentType;
    length;
    sha2;
    description;
    fileUrl;
    content;
    constructor(cfg = {}) {
        const { contentType, length, sha2, usageType, display, description, fileUrl } = cfg;
        this.contentType = contentType;
        this.length = length;
        this.sha2 = sha2;
        this.usageType = usageType;
        this.display = display;
        this.description = description;
        this.fileUrl = fileUrl;
        if (cfg.content) {
            if (typeof cfg.content === 'string') {
                this.setContentFromString(cfg.content);
            }
            else {
                this.setContent(cfg.content);
            }
        }
    }
    asVersion(version = '1.0.3') {
        const { contentType, display, length, sha2, usageType, fileUrl, description } = this;
        const result = {
            contentType,
            display,
            length,
            sha2,
            usageType,
            fileUrl,
            description
        };
        return result;
    }
    getLangDictionaryValue = Utils.getLangDictionaryValue;
    setContent(content) {
        this.content = content;
        this.length = content.byteLength;
    }
    setContentFromString(content) {
        const _content = Utils.stringToArrayBuffer(content);
        this.setContent(_content);
    }
    getContentAsString() {
        return this.content && Utils.stringFromArrayBuffer(this.content);
    }
    fromJSON(attachmentJSON) {
        const _attachment = JSON.parse(attachmentJSON);
        return new Attachment(_attachment);
    }
    _defaultEncoding = 'utf-8';
}
